import {
  ComparatorContext,
  GraphSolarPanelsApi,
  getCalculateSessionId,
} from '@kizi/comparator-core';
import { Button, Div, Heading, P } from '@kizi/core-components';
import React, { useContext, useEffect, useState } from 'react';
import { formatPrice, isMobile } from '../../utils/global';
import { MobileLayover } from '../MobileLayover';
import { Window } from '../Window';

export const DynamicFormModal = ({ showModal, setShowModal }): JSX.Element => {
  const context = useContext(ComparatorContext);
  const { api } = useContext(ComparatorContext);
  const [content, setContent] = useState<{ name: string; price: string }[]>([]);

  useEffect(() => {
    (async () => {
      const getStateFromLocalStorage = context.getStateFromLocalStorage;
      const comparatorName = context.name;
      const persistedState = getStateFromLocalStorage();

      if (comparatorName === 'os-solar-panels') {
        const overview = persistedState?.context?.initialSteps[4];
        const selectedProductField = overview?.fields.find(
          (f) => f.name === 'selectedProduct'
        )?.value;
        const selectedProduct = JSON?.parse(String(selectedProductField) || '');
        let supplierId = Number(selectedProduct?.supplierExternalId);
        if (supplierId) {
          const products = (await (
            api as GraphSolarPanelsApi
          ).getProductsForSupplier(
            supplierId,
            getCalculateSessionId(),
            `${process.env.KIZI_PUBLIC_DOMAIN}/solarpanels/graphql`
          )) as any;
          setContent(
            products
              ?.filter((el) => el.associatedSuppliers.includes(supplierId))
              ?.map(({ name, price }) => ({ name, price }))
          );
        }
      }
    })();
  }, []);

  const _children = (
    <Div p={0} display="flex" flexDirection="column" gridGap={5}>
      <Heading
        variant="H2"
        as="h2"
        fontSize={isMobile() ? '24px!important' : '32px!important'}
        m={0}
        p={0}
      >
        {'Alle mogelijke extra kosten'}
      </Heading>
      <Div display="flex" flexDirection="column" gridGap={3}>
        {content?.map((el) => (
          <Div key={el?.name} display="flex" justifyContent="space-between">
            <P variant="footnoteRegular">{el?.name}</P>
            <P variant="footnoteRegular" fontWeight={700}>
              {formatPrice(el?.price)}
            </P>
          </Div>
        ))}
      </Div>
      <P variant="captionRegular" fontSize={2} lineHeight={2} color="#727888">
        {
          'Deze kosten worden alleen in rekening gebracht wanneer uit de technische schouw blijkt dat deze opties nodig zijn voor jouw woning.'
        }
      </P>
      <Div display="flex" justifyContent="center">
        <Button
          mb={4}
          width="100%"
          height="40px"
          maxWidth={'328px'}
          fontSize={3}
          variant="moreInformationDark"
          onClick={() => {
            setShowModal(false);
          }}
        >
          {'Sluiten'}
        </Button>
      </Div>
    </Div>
  );

  return isMobile() ? (
    <MobileLayover
      p={5}
      show={showModal}
      onClose={() => setShowModal(false)}
      showIcon={false}
      noHorizontalPadding
    >
      {_children}
    </MobileLayover>
  ) : (
    <Window
      type="modal"
      show={showModal}
      onClose={() => setShowModal(false)}
      modalProps={{
        show: showModal,
        noCloseIcon: true,
        modalContainerDivProps: { width: '500px !important' },
        children: _children,
      }}
    >
      <P>{''}</P>
    </Window>
  );
};
